export const listFonts = {
  fontWeight: 700,
  fontFamily: "Roboto Slab",
};
